export class AwsRdsResourceStorageSettings {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "string",
            "format": ""
        },
        {
            "name": "iops",
            "baseName": "iops",
            "type": "number",
            "format": ""
        },
        {
            "name": "throughput",
            "baseName": "throughput",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsRdsResourceStorageSettings.attributeTypeMap;
    }
    constructor() {
    }
}
